// extracted by mini-css-extract-plugin
module.exports = {"base":"skeleton_base__BEmuX","active":"skeleton_active__aHq12","skeleton":"skeleton_skeleton__wJK8b"};